export default __webpack_public_path__ + "static/media/USA.229df745.svg";